/**
 * Clients opened by a direct link `https://<widget host>/<slug>`: the link opens the widget
 * in fullscreen with the client's API key, for the given property or building area.
 */
export type CompanyLink = {
  apiKey: string;
  propertyId?: string;
  buildingAreaId?: string;
}

export const COMPANY_LINKS: Record<string, CompanyLink> = {
  'emporia': {
    apiKey: '03MYUEH0.r6NomgA7qiBTU774rq6aKghbHbmqq9Z0',
    propertyId: 'd79f013f-355e-49b8-b2b2-7fc257686036',
  },
  'ica-simrishamn': {
    apiKey: 'YfBkJ1oX.6U9t8MQ1ZB33iVCYQUji96HJYeWFGhRW',
    propertyId: '8b5fa4e3-8ae7-4923-b2d4-7e66d1f3cecb',
  },
  'nackaforum': {
    apiKey: 'ZbYfzljo.0GyAfuS3R5lw2GlwrTWrqdH2mhJangGK',
    propertyId: '92c64452-b581-4453-a9b8-29203ed79d92',
  },
  'etage-shopping': {
    apiKey: '0NxF7MNt.OUP5KtxUh6AwK4OPgL2gvgh8ApU4PbDr',
    propertyId: '85514832-67f2-40de-a087-ec3157d4f181',
  },
  'helsingborg-lekplatser': {
    apiKey: 'uGJDrzVE.iggXh1MHksKyjH0AK3UMCWFBDQqIluFe',
    buildingAreaId: '8f718be6-a4cf-428c-b2b9-3c5046b132c5',
  },
  'gallerian-sthlm': {
    apiKey: '2bipiFPr.skeOlGGhYIRzpGvTGGW5w6Ao4FBCvzyA',
    propertyId: '70a218b7-7c91-441a-bfd5-aba0fb976241',
  },
  'mood-sthlm': {
    apiKey: 'AlsEfW77.RumwsS8OvdnemPWGKr7cI3tZq5YauzHT',
    propertyId: 'f3258c3a-c83c-46d9-b850-f3c54ae8335f',
  },
  'faltoversten-sthlm': {
    apiKey: 'v8sR8KAr.VnPInVwdQ7Rnhd1MU348c5kAS5HoCdGI',
    propertyId: '140af766-432b-46f6-8872-42227a249039',
  },
  'vala': {
    apiKey: 'irwLhzHo.lMLU09DkxvdlnSfh9SobrX4YNxkXvi10',
    propertyId: '7ae4fe80-ac1c-4d61-a9c8-2fcc05690c46',
  },
  'mvg': {
    apiKey: 'RZCfnufD.sc0oBsEBraDZNeXLVxjNBlFz69s4lHNh',
    propertyId: 'd797ee0b-16fb-4cac-8cb1-2e2fc9d91c9e',
  },
  'funnys-adventure': {
    apiKey: 'K3bNyqk6.GTV5HbtHjsQtCXfaXNGtXH6HiQZe7myX',
    propertyId: 'cf2bc058-5265-4100-882e-cd07991dfc7f',
  },
  'jarfalla-kommun': {
    apiKey: '1oqUPSal.ALVNieYjysRxM83tbz6qBxJduJdlrvkz',
    buildingAreaId: '78e4e95a-c360-44c4-9e1b-1cad77f95f67',
  },
  'siba-huset': {
    apiKey: 'CJgPs38w.LKZGcAXZ1dXMDGgsSRJe62rJrT24j78t',
    propertyId: '8c973a63-d0c4-47f4-b2c9-5b6736ffdfc0',
  },
}
